import { defineStore } from 'pinia'
import $api from '@/plugins/axios';
import { useCommonStore } from '@/store/common.store';

// refresh token 동시성 제어 전역 Promise용 변수
// 지우지 말것!
let refreshTokenPromise = null;
let isRefreshing = false;
export const useAuthStore = defineStore('AuthStore', {
  state: () => ({
    accessToken: null,
  }),
  actions: {
    /** digested code 유효성 확인(이메일 유효시간 체크용) */
    async getValid(params) {
      return await $api.post(`/auth/valid`, {code : params.code});
    },
    /** 원장 가입용 이메일 전송 */
    async postEmail(params) {
      return await $api.post('/auth/email', { email: params.email });
    },
    /** 원장 가입 코드 검증 */
    async putEmail(params) {
      return await $api.put('/auth/email', { code: params.code });
    },
    /** 원장 가입 */
    async postOwners(params) {
      return await $api.post('/customers/owners/register', params);
    },
    /** 원장 가입 최종 완료 (구독서비스 동의추가) */
    async postAcceptSubscription() {
      return await $api.post('/customers/owners/accept-subscriptions');
    },
    /** 이메일 중복 체크 */
    async getGroupdIdExist(params) {
      return await $api.get(`/auth/group-id/exists?groupId=${params.groupId}`);
    },
    /** 로그인 */
    setAccessToken(token) {
      this.accessToken = token;
    },

    clearToken() {
      this.accessToken = null;
    },
    async postLogin(params) {
      const res = (await $api.post('/auth/login', {
        email: params.userId,
        password: params.passwd,
      }))
      const accessToken = res?.data?.accessToken;
      if (accessToken) {
        console.log("## set success access token")
        this.setAccessToken(accessToken);
      }
      return res;
    },
    /** 로그아웃 */
    async postLogOut() {
      try {
        await $api.post('/auth/logout');
      } catch (e) {
        this.$handleError(e);
      } finally {
        this.clearToken();
        useCommonStore().clearSessions();
      }
    },
    connectedCamsV2LocalApp() {
      return process.env.BASE_CAMSTUDY_URL?.startsWith('http://localhost')
    },
    removeWebStorageUserData() {
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('userName');
      sessionStorage.removeItem('userEmail');
      sessionStorage.removeItem('userProfileImageUrl');
      sessionStorage.removeItem('userComment');
      localStorage.setItem('grm-remember-groupName','');
    },
    handleLogoutCamStudy() {
      this.removeWebStorageUserData()
      this.handleRedirectPage()
    },
    handleRedirectPage() {
      const isLocal = process.env.ENV === 'local';
      const isConnectedCamsV2LocalApp = this.connectedCamsV2LocalApp();
      location.href = isLocal && !isConnectedCamsV2LocalApp
        ? '/system/auth/login'
        : `${process.env.BASE_CAMSTUDY_URL}/auth/logout?type=oligo`;
    },
    /** 토큰 재발급 */
    async refreshAccessToken() {
      if (isRefreshing) {
        return refreshTokenPromise
      }
      isRefreshing = true;
      refreshTokenPromise = $api.post('/auth/refresh-token')
        .then(res => {
          if (res?.data?.accessToken) {
            this.setAccessToken(res.data.accessToken);
            return res.data.accessToken;
          }
          return null;
        })
        .catch(e => {
          this.clearToken();
          return null;
        })
        .finally(() => {
          isRefreshing = false;
          refreshTokenPromise = null;
        });
      return refreshTokenPromise;
    },
    /** 비밀번호 초기화용 이메일 전송 */
    async postResetRequestPw(params) {
      return await $api.post('/auth/email/request-reset-password', { email: params.email });
    },
    /** 비밀번호 초기화 */
    async putResetRequestPw(params) {
      return await $api.put('/auth/email/reset-password', {
        password: params.password,
        code: params.code,
      });
    },
    /** 운영관리자 가입용 Api */
    async putManagerAuth(params) {
      return await $api.put('/auth/email/managers', {
        code: params.code,
        name: params.name,
        phone: params.phone,
        password: params.password,
      });
    },
    $handleError(e) {
      this.$nuxt.$sentry.captureException(e);
      this.$nuxt.error({ statusCode: e.response.status });
    },
    /** 전화번호 인증 요청 */
    async postCertifyPhone(params) {
      return await $api.post(`/auth/phone`, params)
    },
    async putCertifyPhone(params) {
      return await $api.put(`/auth/phone`, params)
    }
  },
  getters: {
    getAccessToken: (state) => state.accessToken,
    isLoggedIn: (state) => !!state.accessToken,
  }
})
